// extracted by mini-css-extract-plugin
module.exports = {"container":"SubprojectCard_container__2ObHO","label":"SubprojectCard_label__2ep7L","sub":"SubprojectCard_sub__3gGX3"};